import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import { Box, Text, Link } from 'components/ui';
import {
    colors, fontSizes, fontWeights, lineHeights, space
} from 'style/config';
import * as legalConstants from 'constants/legal';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import LoginEN from 'components/Login/locales/Login_en_US';
import LoginFR from 'components/Login/locales/Login_fr_CA';

const getText = LanguageLocaleUtils.getLocalisedDataFromResource(LoginEN, LoginFR);

/**
 * LegalCompliance Component
 * @param {boolean} isOAuth2Flow - Whether this is an OAuth2 external authentication flow
 */
const LegalCompliance = ({ isOAuth2Flow }) => {
    return isOAuth2Flow ? (
        <Box css={styles.termsContainer}>
            <Text
                is='p'
                fontSize={fontSizes.xs}
                color={colors.gray}
                lineHeight={lineHeights.tight}
            >
                {getText('oauth2TermsPrefix')}
                <Link
                    href={legalConstants.TERMS_OF_USE_LINK}
                    color={colors.blue}
                    underline={true}
                    fontWeight={fontWeights.bold}
                    target='_blank'
                    rel='noopener noreferrer'
                >
                    {getText('termsOfUse')}
                </Link>
                {getText('oauth2TermsMiddle')}
                <Link
                    href={legalConstants.PRIVACY_POLICY_LINK}
                    color={colors.blue}
                    underline={true}
                    target='_blank'
                    rel='noopener noreferrer'
                >
                    {getText('privacyPolicy')}
                </Link>
                {getText('oauth2ChatGPTPrivacy')}
                <Link
                    href={legalConstants.CHATGPT_PRIVACY_POLICY_LINK}
                    color={colors.blue}
                    underline={true}
                    target='_blank'
                    rel='noopener noreferrer'
                >
                    {getText('privacyPolicy')}
                </Link>
                {getText('oauth2AuthorizeSuffix')}
            </Text>
        </Box>
    ) : (
        <Box css={styles.termsContainer}>
            <Text
                is='p'
                fontSize={fontSizes.xs}
                color={colors.gray}
                lineHeight={lineHeights.tight}
            >
                {getText('termsPrefix')}
                <Link
                    href='/beauty/terms-of-use'
                    color={colors.blue}
                    underline={true}
                    fontWeight={fontWeights.bold}
                    target='_blank'
                    rel='noopener noreferrer'
                >
                    {getText('termsOfUse')}
                </Link>
                {getText('termsAnd')}
                <Link
                    href='/beauty/privacy-policy'
                    color={colors.blue}
                    underline={true}
                    target='_blank'
                    rel='noopener noreferrer'
                >
                    {getText('privacyPolicy')}
                </Link>
            </Text>
        </Box>
    );
};

const styles = {
    termsContainer: {
        marginBottom: space[5]
    }
};

export default wrapFunctionalComponent(LegalCompliance, 'LegalCompliance');
